export default "__VITE_ASSET__BpFvBWyf__"